<template>
  <div class="log">
    <div class="search">
      <div class="search_box">
        <div class="search_options_box" style="width: 30%">
          <span style="width: auto;white-space: nowrap">选择时间</span>
          <el-date-picker
            type="date"
            v-model="startDate"
            value-format="yyyy-MM-dd"
            placeholder="     请选择开始时间"
            id="start"
            style="margin-right: 5px">
          </el-date-picker>
          <span style="width: auto">~</span>
          <el-date-picker
            type="date"
            v-model="endDate"
            value-format="yyyy-MM-dd"
            placeholder="     请选择结束时间"
            id="end">
          </el-date-picker>
        </div>
        <div class="search_btn_box">
          <button :class='["search_btn","green","icon_btn","clearborder"]' @click="getDateData()"><span class="el-icon-search"></span>查询</button>
        </div>
        <!--<div class="add_btn_box">
          <button :class='["add_btn","add","icon_btn","clearborder"]'><span class="icon-9"></span>新增灯杆</button>
          <button :class='["add_btn","delete","icon_btn","clearborder"]'><span class="icon-9"></span>批量删除</button>
        </div>-->
      </div>
    </div>
    <!--        表格-->
    <div class="table_content">
      <table>
        <thead>
        <tr>
          <th style="padding-left: 30px"><input type="checkbox" name="checkbox" style="width: 16px;height: 16px"></th>
          <th>访问日期</th>
          <th>浏览器类型</th>
          <th>登录账号</th>
          <th>角色名称</th>
          <th>IP地址</th>
          <th>MAC地址</th>
          <th>操作内容</th>
        </tr>
        </thead>
        <tbody>
        <tr  v-for="(item,index) in tabledata">
          <td style="padding-left: 30px"><input type="checkbox" name="checkbox"></td>
          <td>{{item.date}}</td>
          <td>{{item.type}}</td>
          <td>{{item.account}}</td>
          <td>{{item.name}}</td>
          <td>{{item.ip}}</td>
          <td>{{item.mac}}</td>
          <td>{{item.operation}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="table_paging">
      <p>当前记录<span>1</span>到<span>5</span>条，共<span>45</span>条记录
        <button
          v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
        <button
          v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
        第<span>1</span>/<span>5</span>页
        <button
          v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
        <button
          v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "log",
    data() {
      return {
        startDate:'',
        endDate:'',
        search: [
          {
            title: '起始日期',
            select: [
              {option: "请选择日期"},
            ]
          },
          {
            title: '结束日期',
            select: [
              {option: "请选择日期"},
            ]
          }
        ],
        tabledata: []
      }
    },
    mounted() {
      this.getDateData();
    },
    methods:{
      getDateData() {
        fetch("/api/v1/access/list", {
          method: 'post',
          body: JSON.stringify({
            start_datetime:this.startDate,
            end_datetime:this.endDate,
            "page_start":0,
            "page_size":10,
          })
        }).then(result => {
          return result.json();//解析流
        }).then(data => {
          this.tabledata = data.data;
          this.totalCount = data.total_count;
          this.totalPage = Math.ceil(this.totalCount / this.pageSize);
          this.startDate='';
          this.endDate='';
        }).catch((error) => {
          console.log(error);
        });
      },

    }
  }
</script>

<style scoped>
  .log{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }
  .table_content{
    width: 100%;
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th{
    background-color: #0e345b;
  }
  .table_content > table tr td{
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input{
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n){
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn{
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }
  .table_select{
    background: transparent;
    border: transparent;
    outline: transparent;
    color: #FFFFFF;
    padding: 5px 10px;
  }
  .table_select>option{
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Setting/log.vue